export default (function (className, styles) {
  if (!styles[className]) {
    throw new Error("Could not resolve the styleName ".concat(className));
  }
  return styles[className];
});